<template>
  <div class="environment-picker uk-flex uk-flex-center">
    <div>
      <button v-if="!environmentIsDefault" class="uk-button" @click="reset()">Reset</button>
      <button class="uk-button uk-button-primary" type="button">{{environment}}</button>
      <div uk-dropdown>
        <ul class="uk-nav uk-dropdown-nav">
          <li v-for="env in validEnvironments">
            <a class="uk-text-center drop-down-text" href="#" @click="selectEnvironment(env)">{{env}}</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState, mapActions} from 'vuex'
  import Environment, {DEV, UAT, PREPROD, PROD, SMEX_URL, SMEX_PROD_URL, LOCALHOST} from './../../plugins/environment'
  import {ENVIRONMENT_OVERRIDE} from './../../plugins/feature/feature-list'
  import {FEATURE_NAMESPACE, SWITCH_AND_VALUE} from './../../plugins/feature/module/types'

  export default {
    name: 'environment-picker',
    computed: {
      ...mapState(FEATURE_NAMESPACE, {
        environmentOverrideEnabled: state => state[ENVIRONMENT_OVERRIDE.name] && state[ENVIRONMENT_OVERRIDE.name].enabled,
        currentEnvironmentOverride: state => state[ENVIRONMENT_OVERRIDE.name] ? state[ENVIRONMENT_OVERRIDE.name].value : this.environment
      }),
      validEnvironments() {
        const host = Environment.getHostname()
        if (host === 'exchange.smarttech-preprod.com' ||
          host === SMEX_URL ||
          host === SMEX_PROD_URL) {
          return [DEV, UAT, PREPROD, PROD]
        } else if (host.match(LOCALHOST)) {
          return [DEV]
        } else {
          return [DEV, UAT, PREPROD]
        }
      },
      environmentIsDefault() {
        return this.environment === Environment.getDefaultEnvironment()
      },
      environment() {
        return Environment.getEnv()
      }
    },
    methods: {
      ...mapActions(FEATURE_NAMESPACE, {
        setSwitchAndValue: SWITCH_AND_VALUE
      }),
      selectEnvironment(env) {
        if (env !== this.environment) {
          this.setSwitchAndValue({
            [ENVIRONMENT_OVERRIDE.name]: {
              enabled: !!env,
              value: env
            }
          }).then(() => {
            window.location.reload()
          })
        }
      },
      reset(reload = true) {
        this.setSwitchAndValue({
          [ENVIRONMENT_OVERRIDE.name]: {
            enabled: false,
            value: null
          }
        }).then(() => {
          if (reload && !this.environmentIsDefault) {
            this.signOut()
              .then(() => {
                window.location.reload()
              })
          }
        })
      },
      signOut() {
        return new Promise((resolve) => {
          this.$auth.id.signOut()
          resolve()
        })
      }
    }
  }
</script>

<style scoped lang="scss">
.drop-down-text{
  text-transform: uppercase;
}
</style>
